import React, { useEffect } from 'react';
import { IoArrowUpCircleOutline } from "react-icons/io5";

export default function ChildrenPrivacypolicy() {

  useEffect(() => {
    scrollToTop();
  }, [])

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <div style={{ marginTop: "10vh" }}>

      <div className='container' style={{ marginTop: "6%" }}>

        <p style={{ fontSize: '3em', fontWeight: 500, color: "#DC143C" }}>Child Safety Policy</p>

        {/* Zero Tolerance */}
        <p className='text-start' style={{ fontSize: '1.2em', fontWeight: 600, color: "#000" }}>Zero-Tolerance Policy :</p>
        <p className='text-start' style={{ fontSize: '1.1em', fontWeight: 400, color: "#333" }}>
          Jai Club Member has a zero-tolerance policy for child sexual abuse and exploitation (CSAE).
          We prohibit any content, behavior, or material that sexualizes minors. Violations result in
          immediate account termination and reporting to relevant authorities including NCMEC
          (National Center for Missing & Exploited Children).
        </p>

        {/* Prohibited Content */}
        <p className='text-start' style={{ fontSize: '1.2em', fontWeight: 600, color: "#000", marginTop: "20px" }}>Prohibited Content & Behavior :</p>
        <p className='text-start' style={{ fontSize: '1.1em', fontWeight: 400, color: "#333" }}>
          The following are strictly prohibited on Jai Club Member:
        </p>
        <ul style={{ fontSize: '1.1em', fontWeight: 400, color: "#333", lineHeight: "2em" }}>
          <li>Any content that sexualizes, exploits, or endangers minors</li>
          <li>Grooming behavior or inappropriate communication with minors</li>
          <li>Sharing, distributing, or requesting child sexual abuse material (CSAM)</li>
          <li>Any attempt to solicit personal information from minors</li>
          <li>Content that normalizes or glorifies abuse of children</li>
        </ul>

        {/* Reporting */}
        <p className='text-start' style={{ fontSize: '1.2em', fontWeight: 600, color: "#000", marginTop: "20px" }}>Reporting Mechanism :</p>
        <p className='text-start' style={{ fontSize: '1.1em', fontWeight: 400, color: "#333" }}>
          Users can report child safety concerns directly within the app using the in-app report feature
          available on every profile and post. All reports are reviewed promptly by our moderation team.
          We are committed to responding to child safety reports within 24 hours.
        </p>

        {/* Enforcement */}
        <p className='text-start' style={{ fontSize: '1.2em', fontWeight: 600, color: "#000", marginTop: "20px" }}>Enforcement & Action :</p>
        <p className='text-start' style={{ fontSize: '1.1em', fontWeight: 400, color: "#333" }}>
          Upon detection or report of any CSAE violation:
        </p>
        <ul style={{ fontSize: '1.1em', fontWeight: 400, color: "#333", lineHeight: "2em" }}>
          <li>The account will be immediately suspended and permanently terminated</li>
          <li>All related content will be removed from the platform</li>
          <li>The incident will be reported to NCMEC and relevant regional/national authorities</li>
          <li>Full cooperation will be provided to law enforcement agencies</li>
        </ul>

        {/* Legal Compliance */}
        <p className='text-start' style={{ fontSize: '1.2em', fontWeight: 600, color: "#000", marginTop: "20px" }}>Legal Compliance :</p>
        <p className='text-start' style={{ fontSize: '1.1em', fontWeight: 400, color: "#333" }}>
          Jai Club Member complies with all applicable child safety laws and regulations, including but
          not limited to the Protection of Children from Sexual Offences (POCSO) Act in India, and
          cooperates fully with national and regional law enforcement authorities to ensure the safety
          of children on our platform.
        </p>

        {/* Contact */}
        <p className='text-start' style={{ fontSize: '1.2em', fontWeight: 600, color: "#000", marginTop: "20px" }}>Contact for Child Safety Concerns :</p>
        <p className='text-start' style={{ fontSize: '1.1em', fontWeight: 400, color: "#333" }}>
          If you have any concerns regarding child safety on Jai Club Member, please contact us at:{" "}
          <a href="mailto:Info@jaiclub.in" style={{ color: "#DC143C" }}>Info@jaiclub.in</a>.
          Our designated safety officer is available to address any CSAM prevention or compliance queries.
        </p>

        {/* Last Updated */}
        <p className='text-start' style={{ fontSize: '0.95em', fontWeight: 400, color: "#888", marginTop: "30px", marginBottom: "60px" }}>
          Last Updated: June 2025
        </p>

      </div>

      <div
        className="scroll-to-top-button rounded-2"
        onClick={scrollToTop}
        style={{
          width: 40,
          height: 40,
          backgroundColor: "#ff68f0",
          color: "#fff",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
        }}
      >
        <IoArrowUpCircleOutline style={{ fontSize: 30 }} />
      </div>

    </div>
  )
}